import { releaseChannel } from "./release-channel";

/** Stable dimensions shared by product analytics and error reporting. */
export function telemetryEnvironment(): string {
  const mode = import.meta.env.MODE;
  if (mode === "test") return "test";
  const channel = releaseChannel();
  if (channel) return channel === "local" ? "development" : channel;
  if (mode === "development" || mode === "local-dev") return "development";
  if (window.location.hostname === "preview.denker.ai" || mode === "preview") {
    return "preview";
  }
  return mode === "prod" || mode === "production" ? "production" : mode;
}

export function getTelemetryContext() {
  return {
    app_version:
      (import.meta.env.VITE_APP_VERSION as string | undefined) || "unknown",
    environment: telemetryEnvironment(),
    event_schema_version: 2,
  };
}
